export default __webpack_public_path__ + "444aa2ecb7b7d50277b4efa93870c2d1.png";